import React from 'react';
import Container from '@/components/@base/container';
import { useGetAdvertisement } from '@/services/hooks';
import cn from '@/lib/clsxm';
import { useSearchParams } from 'react-router-dom';

const Banner = () => {
  const [searchParams] = useSearchParams();
  const { data: advertise } = useGetAdvertisement(7, searchParams.get('pgc') as string);

  if (!advertise?.ads?.[0]?.banner) {
    return null;
  }

  return (
    <Container className='relative'>
      <img
        src={advertise.ads[0].banner}
        alt='ads'
        className={cn('min-h-10 w-full rounded-lg')}
      />
    </Container>
  );
};

export default Banner;
